import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormGroup } from '@angular/forms';
import { RoomModel, RoomType, ROOM_TYPES } from 'projects/core/src/lib/models/room.model';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { LocationModel } from 'projects/core/src/lib/models/location.model';
import { CustomValidators } from 'projects/core/src/lib/validators/custom.validators';

@Component({
  selector: 'app-room-basedata',
  templateUrl: './room-basedata.component.html',
  styleUrls: ['./room-basedata.component.scss']
})
export class RoomBasedataComponent extends BaseForm implements OnInit, OnChanges {

  @Input() room: RoomModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public form = this.fb.group({
    active: new UntypedFormControl(false),
    name: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('', [Validators.required]),
    location: new UntypedFormControl('', [Validators.required]),
    capacity: new UntypedFormControl(''),
    zip: new UntypedFormControl(''),
    street: new UntypedFormControl(''),
    addition: new UntypedFormControl(''),
    mail_registration: new UntypedFormControl('', [Validators.required, CustomValidators.email()]),
    mail_catering: new UntypedFormControl('', [CustomValidators.email()]),
  });

  public locations: Array<LocationModel> = [];
  public types: Array<SelectItem> = [];
  public roomTypes = ROOM_TYPES;

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private confirmation: ConfirmationService,
    public transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    this.loading = true;
    this.types = FormHelper.getSelectList(ROOM_TYPES, null, this.transloco);
    this.api.getModels('locations').subscribe({
      next: (result: any) => {
        this.locations = [];
        result.data.forEach((location: any) => {
          this.locations.push(new LocationModel().deserialize(location));
        });
      }
    }).add(() => {
      this.loading = false;
    });
    this.ui.setFocus();
  }

  ngOnChanges(): void {
    this.items = [];
    if (this.room !== null) {
      if (this.auth.hasRight('admin.room.delete')) {
        this.items.push({
          label: this.transloco.translate('common.labels.delete'),
          icon: 'pi pi-trash',
          styleClass: 'danger-button',
          disabled: (!this.room.deletable),
          command: () => {
            this.onDelete();
          }
        });
      }
    }
  }

  onSubmit(): void {
    this.ui.hideMessage();
    const payload: any = this.form.value;
    payload.location = payload.location?.id || null;
    if (this.form.valid === true && payload.location) {
      this.submitting = true;
      this.api.saveModel('rooms', this.room.id, payload).subscribe({
        next: (result: any) => {
          this.room.deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.room.name }), this.transloco.translate('common.saved'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onDelete(): void {
    if (this.auth.hasRight('admin.room.delete')) {
      this.confirmation.confirm({
        message: this.transloco.translate('common.messages.really_delete', { value: this.room.name }),
        header: this.transloco.translate('common.really_delete'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.api.deleteModel('rooms', this.room.id).subscribe({
            next: () => {
              this.ui.toastSuccess(this.transloco.translate('common.messages.deleted', { value: this.room.name }), this.transloco.translate('common.deleted'));
              this.router.navigate(['/rooms']);
            },
            error: (error: any) => {
              this.ui.toastError(this.transloco.translate(error.message));
            }
          });
        }
      });
    }
  }

  protected startEdit(): void {
    if (this.room !== null) {
      this.form.patchValue({
        active: this.room.active,
        name: this.room.name,
        type: this.room.type,
        location: this.room.location,
        capacity: this.room.capacity,
        zip: this.room.zip,
        street: this.room.street,
        addition: this.room.addition,
        mail_registration: this.room.mail_registration,
        mail_catering: this.room.mail_catering,
      });
    }
    this.setEdit.emit('basedata');
    super.startEdit();
    this.ui.setFormFocus();
  }

  protected stopEdit(): void {
    this.setEdit.emit(null);
    super.stopEdit();
    this.ui.setFocus();
  }

}
